// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const WifiGradientIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 48 48">
    <path
      fill="url(#wifi-gradient_svga)"
      d="m2 18 4 4a25.46 25.46 0 0 1 36 0l4-4a31.13 31.13 0 0 0-44 0m16 16 6 6 6-6a8.47 8.47 0 0 0-12 0m-8-8 4 4a14.15 14.15 0 0 1 20 0l4-4a19.8 19.8 0 0 0-28 0"
    />
    <defs>
      <linearGradient
        id="wifi-gradient_svga"
        x1={2}
        x2={32.56}
        y1={8.89}
        y2={49.99}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "WifiGradient",
);
export default WifiGradientIcon;
